<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th class="checkbox tableCheckbox">
            <input type="checkbox" id="checkAll" v-model="checkedAll" @change="onCheckedAll($event)">
            <label for="checkAll"><span class="blind">check all</span></label>
          </th>
          <th>{{locale.title}}</th>
          <th class="center">{{locale.table_createat}}</th>
          <th class="center">{{locale.table_updateat}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!list.length" class="noData"><td colspan="5">{{locale.product_nodata}}</td></tr>
        <tr v-else v-for="product in list" :key="product.id">
          <td class="checkbox tableCheckbox">
            <input type="checkbox" name="checkItem" :id="`check${product.id}`" :value="product.id" v-model="checkedItem" @change="onCheckedItem($event)">
            <label :for="`check${product.id}`"><span class="blind">check</span></label>
          </td>
          <td><router-link :to="{name: 'productItem', params: {id: product.id}}" class="subject">{{product.title}}</router-link></td>
          <td class="center date">{{date(product.created)}}</td>
          <td class="center date">{{date(product.updated)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DATE from '@/common/date'

export default {
  name: 'ProductList',
  props: [
    'locale',
    'init',
    'list'
  ],
  watch: {
    init (isInit) {
      if (isInit) {
        this.checkedItem = []
      }
    },
    checkedItem (ids) {
      this.$emit('checked', ids)
    }
  },
  data () {
    return {
      checkedItem: [],
      checkedAll: false
    }
  },
  methods: {
    date (date) {
      return DATE.toString(date)
    },
    onCheckedAll (e) {
      const checked = e.target.checked
      this.checkedAll = checked
      let allId = []
      if (checked) {
        this.list.forEach(x => {
          allId.push(x.id)
        })
      }
      this.checkedItem = allId
    },
    onCheckedItem (e) {
      const checked = e.target.checked
      if (!checked) {
        this.checkedAll = false
      }
    }
  }
}
</script>
